<template>
  <div>
    <v-container fluid>
      <date-filter
        v-model="selectedDate"
        @changeDate="onDateChanged"
        :showTime="true"
        :default-filter="'last_7_days'"
      ></date-filter>
      <v-data-table
        :rows-per-page-items="[25, 40, 50, 100]"
        :loading="loading"
        :headers="headers"
        :items="data"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <v-avatar size="30">
                <img v-if="props.item.photourl" :src="props.item.photourl" width="30" height="30" />
                <img
                  v-else
                  :src="'/static/img/assets/livechat/profile.png'"
                  width="30"
                  height="30"
                />
              </v-avatar>
            </td>
            <td>
              <div>{{ props.item.name }}</div>
            </td>
            <td>
              <div>{{ props.item.redeem_point | numberFormat }}</div>
            </td>
            <td>
              <div>{{ props.item.redeem_detail }}</div>
            </td>
            <td>
              <div>{{ props.item.redeem_date | dateFormat('DD/MM/YYYY') }}</div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import moment from 'moment'

export default {
  components: {
    DateFilter
  },
  data() {
    return {
      loading: true,
      headers: [
        { text: '', value: 'photourl', align: 'center' },
        { text: 'ชื่อ', value: 'name' },
        { text: 'คะแนน', value: 'redeem_point' },
        { text: 'สินค้า', value: 'redeem_detail' },
        { text: 'วันที่สะสม', value: 'redeem_date' }
      ],
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm'),
        end: moment().format('YYYY-MM-DD HH:mm')
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getsahapanredeemdetailall()
  },
  methods: {
    onDateChanged() {
      this.getsahapanredeemdetailall()
    },
    getsahapanredeemdetailall() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        startdate: this.selectedDate.start,
        enddate: this.selectedDate.end
      }
      api.getsahapanredeemdetailall(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200 && response.data) {
          this.data = response.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/sahapan/RedeemSummary.vue